import React, { useState } from "react";
import { CommonInputProps, InputHelperText, useInput } from "react-admin";
import { MuiTelInput, MuiTelInputProps } from "mui-tel-input";
import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import { styled } from "@mui/material/styles";
import { FormHelperText } from "@mui/material";
import { phonePattern } from "src/common/UtilFunctions";

export const TelInput = styled(MuiTelInput)`
  .MuiTelInput-IconButton {
    padding: 8px;
  }
  input {
    height: 7px;
  }
`;

export const PhoneInput = (props: PhoneInputProps) => {
  const {
    label,
    validate,
    helperText,
    source,
    defaultValue,
    defaultCountry = "US",
    ...rest
  } = props;

  const {
    field,
    fieldState: { error, invalid, isTouched },
    formState: { isSubmitted },
    isRequired,
  } = useInput({ ...props, source, defaultValue, validate });

  const [value, setValue] = useState(field.value);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isValid, setIsValid] = useState(isValidPhoneNumber(value));

  const handleChange = (newValue) => {
    let index = newValue.indexOf(" ");
    newValue = newValue.replaceAll(" ", "");
    newValue = newValue.slice(0, index) + " " + newValue.slice(index);

    setValue(newValue);

    if (!phonePattern.test(newValue)) {
      field.onChange("");
      setIsValid(false);
      setErrorMessage("Phone number pattern is invalid");
    } else if (!isValidPhoneNumber(newValue, defaultCountry) && phonePattern.test(newValue)) {
      field.onChange("");
      setIsValid(false);
      setErrorMessage("Phone number is invalid");
    } else {
      field.onChange(newValue);
      setIsValid(true);
      setErrorMessage(null);
    }
  };

  return (
    <React.Fragment>
      <TelInput
        {...field}
        value={value}
        onChange={handleChange}
        defaultCountry={defaultCountry}
        focusOnSelectCountry
        label={label}
        required={isRequired}
        MenuProps={{
          style: { maxHeight: "300px" },
        }}
        error={(isTouched || isSubmitted) && invalid && !isValid}
        {...rest}
      />
      <FormHelperText error={helperText !== false || ((isTouched || isSubmitted) && invalid && !isValid)}>
        <InputHelperText
          touched={isTouched || isSubmitted}
          error={errorMessage ?? error?.message}
          helperText={helperText}
        />
      </FormHelperText>
    </React.Fragment>
  );
};

export type PhoneInputProps = CommonInputProps &
  MuiTelInputProps & {
    label: string;
    defaultCountry?: CountryCode;
  };
